import { render, staticRenderFns } from "./GradientHue.vue?vue&type=template&id=707b85a2&scoped=true"
import script from "./GradientHue.vue?vue&type=script&lang=js"
export * from "./GradientHue.vue?vue&type=script&lang=js"
import style0 from "./GradientHue.vue?vue&type=style&index=0&id=707b85a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b85a2",
  null
  
)

export default component.exports